import React from "react";
import {
  Iconography,
  IconographySizes,
  Loader,
  LoaderSizes,
  Pagination,
} from "@hid-galaxy-ui/galaxy-react";
import { useAppSelector } from "../../../../../redux";
import OrderHistoryCard from "../../../../../common/components/OrderHistoryCard";
import OrderDetailModal from "../../../../../common/components/OrderDetailModal";
import "./TabContentOrderHistory.scss";

const TabContentOrderHistory = () => {
  const [detailModalOpen, setDetailModalOpen] = React.useState<boolean>(false);
  const [detailID, setDetailID] = React.useState<string>("");
  const [currentPageNumber, setCurrentPageNumber] = React.useState<number>(1);
  const { allOrders, status } = useAppSelector((state) => state.my_account);

  const onOrderHistoryCardClick = (orderId: string) => {
    setDetailModalOpen(true);
    setDetailID(orderId);
  };

  const pageSize = 5;
  const totalRecords = allOrders.length;
  const paginatedData = allOrders.slice(
    (currentPageNumber - 1) * pageSize,
    currentPageNumber * pageSize
  );
  const handlePageChange = (clickedPageNumber: number | null) => {
    setCurrentPageNumber(clickedPageNumber);
  };

  return (
    <div className="tab-content-order-history">
      {status.orderHistoryLoading ? (
        <div className="loading">
          <Loader variant={LoaderSizes.large} />
        </div>
      ) : allOrders.length > 0 ? (
        <>
          {paginatedData.map((order) => {
            return (
              <OrderHistoryCard
                order={order}
                key={order.id}
                onCardClick={onOrderHistoryCardClick}
                permissionScope="partner"
              />
            );
          })}
          <Pagination
            currentPageNumber={currentPageNumber}
            totalRecords={totalRecords}
            pageSize={pageSize}
            border={true}
            onPageNumberClick={handlePageChange}
          />
        </>
      ) : (
        <div className="no-orders">
          <Iconography icon="cartShopping" size={IconographySizes.Medium} />
          <p>No Products Purchased</p>
        </div>
      )}
      {detailModalOpen && (
        <OrderDetailModal
          setDetailModalOpen={setDetailModalOpen}
          orderID={detailID}
        />
      )}
    </div>
  );
};

export default TabContentOrderHistory;
